import { FC, useContext, useEffect, useState } from 'react';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { ConsentContent } from 'templates/ConsentContent';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';
import { AppContext } from 'templates/AppContextProvider';
import { useGetAgreementText } from 'hooks/u002/useGetAgreementTextHooks';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';

//U002F04 プライバシーポリシー同意画面
type PrivacyPolicyConsentProps = {
  audition: GetAuditionResponse & {
    audition_id: string;
  };
  onNext: () => void;
  onBack: () => void;
};
export const UnauthPrivacyPolicyConsent: FC<PrivacyPolicyConsentProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const [checked, setChecked] = useState(false);
  const { audition } = props;
  const { currentLang } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [privacyPolicyConsent, loading, err] = useGetAgreementText({
    audition_id: audition.audition_id,
    examination_no: audition.examination_no,
    lang: currentLang,
    consent_type: '4', // 4: プライバシーポリシー同意
  });

  const handleNext = () => {
    props.onNext();
  };

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };
  useEffect(() => {
    if (err) {
      setErrorMessage(err.message);
    }
  }, [err]);

  return (
    <>
      {loading && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionForm('TU002_032')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <AppLogoHeader />
      <ConsentContent
        title={tAuditionForm('TU002_117')}
        text={privacyPolicyConsent?.consent_text}
        label={tAuditionForm('TU002_046')}
        nextLabel={tAuditionForm('TU002_047')}
        backLabel={tAuditionForm('TU002_048')}
        checked={checked}
        onChange={handleChange}
        onBack={props.onBack}
        onNext={handleNext}
      />
      <UnauthAppFooter />
    </>
  );
};
